<template>
  <svg id="zonne-energie" viewBox="0 0 85 85">
    <path
      d="M36.7,14.3c1.5-3,4.5-4.9,7.8-4.9c0.2,0,0.5,0,0.7,0c0.6,0,1.2,0.2,1.8,0.3c2.7,0.8,4.8,2.9,5.7,5.5
                c0.8,2.2,0.6,4.7-0.4,6.8c-0.3,0.6-0.6,1.1-1,1.6c-1.7,2.1-4.1,3.2-6.8,3.2c-1.2,0-2.3-0.2-3.4-0.7c-2.3-1-4.1-2.9-4.9-5.3
                C35.5,18.8,35.7,16.4,36.7,14.3 M33.7,18.2c0,2.1,0.6,4.2,1.8,5.9c0.4,0.6,0.8,1.1,1.4,1.6c2,2,4.8,3.2,7.6,3.2h0
                c2.9,0,5.6-1.1,7.6-3.2c0.3-0.3,0.7-0.7,0.9-1.1c0.4-0.5,0.8-1.1,1.1-1.7c0.7-1.4,1.1-3,1.2-4.6v-0.5c0-2.1-0.7-4.1-1.9-5.8
                c-0.2-0.3-0.5-0.7-0.7-1c-0.2-0.2-0.4-0.4-0.6-0.6c-0.5-0.5-1.1-1-1.7-1.4c-1.8-1.1-3.8-1.8-5.9-1.8l-0.3,0
                c-2.8,0.1-5.4,1.2-7.4,3.2c-2,2-3.1,4.6-3.2,7.4L33.7,18.2z"
    />
    <rect x="43.5" width="2.1" height="6.1" />
    <rect
      x="52.2"
      y="6.4"
      transform="matrix(0.7071 -0.7071 0.7071 0.7071 10.8817 41.2205)"
      width="6.1"
      height="2.1"
    />
    <rect
      x="54.2"
      y="25.8"
      transform="matrix(0.7071 -0.7071 0.7071 0.7071 -4.256 47.4943)"
      width="2.1"
      height="6.1"
    />
    <rect
      x="30.7"
      y="27.9"
      transform="matrix(0.7071 -0.7071 0.7071 0.7071 -10.5297 32.357)"
      width="6.1"
      height="2.1"
    />
    <rect x="43.5" y="30.3" width="2.1" height="6.1" />
    <rect x="26.3" y="17.2" width="6.1" height="2.1" />
    <rect x="56.6" y="17.1" width="6.1" height="2.1" />
    <rect
      x="32.8"
      y="4.4"
      transform="matrix(0.7071 -0.7071 0.7071 0.7071 4.6077 26.0835)"
      width="2.1"
      height="6.1"
    />
    <path
      d="M29.1,58h5l3.6,4.3h-5L29.1,58z M36.3,58h5l3.6,4.3h-5L36.3,58z M43.4,58h5l3.6,4.3h-5L43.4,58z M50.5,58h5
                l3.6,4.3h-5L50.5,58z M24.1,52.1h5l3.6,4.2h-5L24.1,52.1z M31.3,52.1h5l3.6,4.2h-5L31.3,52.1z M38.4,52.1h5l3.6,4.2h-5L38.4,52.1z
                 M45.5,52.1h5l3.6,4.2h-5L45.5,52.1z M20.3,47.6l-1.2-1.4h5l3.6,4.2h-5L20.3,47.6z M26.3,46.2h5l3.6,4.2h-5L26.3,46.2z M33.4,46.2
                h5l3.6,4.2h-5L33.4,46.2z M40.5,46.2h5l3.6,4.2h-5L40.5,46.2z M45.9,44.5H17.3h-1.8l0,0l0,0L0.3,62.9L1.8,64l15-18.1l15.2,17.9h0.6
                h28.4h1.8L46.3,44.5H45.9z"
    />
    <g transform="scale(0.5) translate(100,100)">
      <IconVinkjeAppendix />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import IconVinkjeAppendix from '@/components/icon/custom/templates/IconVinkjeAppendix.vue';

@Component({ components: { IconVinkjeAppendix } })
export default class IconZonneEnergieVinkje extends Vue {}
</script>
